import React from "react";

import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import HouseholdNameLink from "./HouseholdNameLink";

interface HouseholdNameToolTipProps {
  householdId: string;
  householdName: string;
  maxWidth?: number;
}

const HouseholdNameToolTip: React.FC<HouseholdNameToolTipProps> = ({
  householdId,
  householdName,
  maxWidth = 200,
}) => {
  const tooltipContent = <Text variant="body">{householdName}</Text>;

  return (
    <Tooltip tooltipText={tooltipContent}>
      <Text
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: `${maxWidth}px`,
        }}
      >
        <HouseholdNameLink
          householdId={householdId}
          householdName={householdName}
        />
      </Text>
    </Tooltip>
  );
};

export default HouseholdNameToolTip;
